<template>
    <b-modal :id="id" dialog-class="modal-lg" @show="show" @shown="shown" no-close-on-backdrop>
        <template slot="modal-header">
            <slot name="modal-title"></slot>
            <b-button class="close" @click="cancel">
                <b-icon-x></b-icon-x>
            </b-button>
        </template>
        <b-overlay :show="loading">
            <slot></slot>
        </b-overlay>
        <template slot="modal-footer">
            <slot name="modal-footer"></slot>
            <b-overlay class="d-inline-block" :show="saveing">
                <b-button variant="primary" @click="ok"><b-icon-file-check></b-icon-file-check>儲存</b-button>
            </b-overlay>
            <b-button variant="secondary" @click="cancel"><b-icon-x></b-icon-x>關閉</b-button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        name: 'modal',
        props: ['id', 'loading', 'saveing'],
        methods: {
            show: function (e) { this.$emit('show', e); },
            shown: function (e) { this.$emit('shown', e); },
            ok: function (e) { this.$emit('ok', e); },
            cancel: function (e) { this.$emit('cancel', e); }
        }
    };
</script>

<style>
</style>